module.exports = __webpack_public_path__ + "static/media/profile_avatar_plug.f8c22d4f.svg";